import script from "./TableFileRow2.vue?vue&type=script&setup=true&lang=js"
export * from "./TableFileRow2.vue?vue&type=script&setup=true&lang=js"

import "./TableFileRow2.vue?vue&type=style&index=0&id=6db1a686&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6db1a686"]])

export default __exports__